import { render } from "./MiniUrneView.vue?vue&type=template&id=5470303e"
import script from "./MiniUrneView.vue?vue&type=script&lang=js"
export * from "./MiniUrneView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__